// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditSeriesModalContent-deleteButton-AsWAU Button-button-paJ9a Link-link-RInnp","labelIcon":"EditSeriesModalContent-labelIcon-K2RWg"};